import { Link } from "react-router-dom";
import { ChevronDown, ArrowRight } from "lucide-react";
import { FaqRichText } from "@/components/faq/FaqRichText";

export function FaqItem({ item, isOpen, hidden, onToggle }) {
  return (
    <details
      id={item.id}
      open={isOpen}
      onToggle={(e) => onToggle(item.id, e.currentTarget.open)}
      data-testid={`faq-item-${item.id}`}
      className={`group scroll-mt-32 border-b border-slate-200 ${hidden ? "hidden" : ""}`}
    >
      <summary
        data-testid={`faq-trigger-${item.id}`}
        className="flex cursor-pointer list-none items-start justify-between gap-4 py-5 [&::-webkit-details-marker]:hidden focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F26522] focus-visible:ring-offset-2 rounded-sm"
      >
        <h3 className="font-display font-bold text-navy-800 text-base sm:text-lg leading-snug transition-colors group-hover:text-[#F26522] group-open:text-[#F26522]">
          {item.q}
        </h3>
        <ChevronDown
          aria-hidden="true"
          className="mt-1 h-5 w-5 shrink-0 text-slate-400 transition-transform duration-200 group-open:rotate-180 group-open:text-[#F26522]"
        />
      </summary>
      <div data-testid={`faq-answer-${item.id}`} className="pb-6 pr-2 sm:pr-10 space-y-3 text-slate-600 text-base leading-relaxed">
        {item.a.map((p, i) => (
          <p key={i}>
            <FaqRichText text={p} />
          </p>
        ))}
        {item.cta && (
          <Link
            to="/contacto"
            data-testid={`faq-cta-${item.id}`}
            className="group/cta mt-2 inline-flex items-center gap-2 rounded-xl border border-[#F26522]/25 bg-[#FEF3EB] px-4 py-3 text-sm font-bold text-[#F26522] transition-colors hover:bg-[#F26522] hover:text-white"
          >
            {item.cta}
            <ArrowRight className="h-4 w-4 transition-transform group-hover/cta:translate-x-1" />
          </Link>
        )}
      </div>
    </details>
  );
}
